
























import { Component,Watch, Prop, Vue } from "vue-property-decorator";
import { mapState } from "vuex";


@Component({
    computed: mapState("auth", ["user"])
})
export default class CheckinList extends Vue {
  @Prop(Object) readonly list!: any;
  user!:any;
  URL: any = this.getURL();
  @Watch("list", { deep: true })
  onFilterChanged() {
    this.URL = this.getURL();
  }



 

  getURL(){
    var url = "https://www.luminare360.com/txt";
    var env ="prod";

  if(process.env.VUE_APP_ENVIRONMENT !="prod"){
    env = process.env.VUE_APP_ENVIRONMENT!;
    url = url.replace("www","dev") + env;
  }

  var u=this.$store.state.auth.user.id;

  return url + "/pages/wait_list_2_wm_web.html?t=" + this.list.TableID +"&u="+ u + "&e=" + env.toUpperCase();
  }

  openInNewTab(url) {
  window.open(url, '_blank')?.focus();
}

 
}
